import { Component, ViewChild, ElementRef, inject, computed } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ChatService } from '../../service';
import { Chat } from '../../model';
import { ViewSignal } from '../../signal';
import { firstValueFrom } from 'rxjs';

@Component({
    selector: 'app-chat',
    imports: [MatIcon],
    templateUrl: './chat.component.html',
    styleUrls: ['./chat.component.scss']
})
export class ChatComponent {
    chatService = inject(ChatService);
    viewSignal = inject(ViewSignal);

    chat = computed<Chat | null>(() => this.viewSignal.chat());

    @ViewChild('chatkit') chatkit: ElementRef;

    public open = false;
    public visible = false;
    public dimmed = true;

    public width: string = '20rem';
    public height: string = '32rem';

    constructor() {
    }

    public async onChat() {
        this.visible = !this.visible;
        this.dimmed = !this.visible;
        if (!this.open) {
            this.open = true;
            setTimeout(async () => {
                await this.load();
            },0);
        }
    }

    private async load(): Promise<void> {
        if (this.open) {
            const element = this.chatkit.nativeElement as any;

            // Wait until the custom element is defined
            await customElements.whenDefined('openai-chatkit').then(() => {
                element.setOptions({
                    api: {
                        getClientSecret: async() => await firstValueFrom(this.chatService.secret())
                    },
                    theme: { colorScheme: 'dark', radius: 'round' }
                });
            });
        }
    }
}
